import { Box, Paper, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Assessment, ArrowOutward } from "@mui/icons-material";
import colors from "../../Constants/colors";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";

export function NoEvaluationsCard({ companyId }: { companyId?: string }) {
  const { t } = useTranslation("singleCompanyComponent");
  const navigate = useNavigate();
  const { colors: workspace } = useWorkspaceColors();

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 2,
        border: `1px solid ${colors.gray200}`,
        textAlign: "center",
        backgroundColor: colors.white,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
        <Assessment
          sx={{ fontSize: "2.5rem", color: workspace.primary_dark }}
        />
      </Box>
      <Typography
        variant="h4"
        sx={{
          fontWeight: 400,
          color: colors.gray900,
          mb: 1,
          fontSize: "1.5rem",
        }}
      >
        {t("noEvaluations.title")}
      </Typography>
      <Link
        component="button"
        onClick={() =>
          navigate("/evaluation", { state: { companyId: companyId } })
        }
        variant="body2"
        sx={{
          color: workspace.primary_dark,
          textDecoration: "underline",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          "&:hover": {
            opacity: 0.8,
            cursor: "pointer",
          },
        }}
      >
        {t("noEvaluations.createLink")}
        <ArrowOutward sx={{ fontSize: "1rem" }} />
      </Link>
    </Paper>
  );
}
